var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pricing-form',{attrs:{"requiredFilters":_vm.requiredFilters,"showMarginFactor":"","priority":_vm.priority,"moduleSlug":_vm.moduleSlug,"formName":"everyday-pricing"}})
}
var staticRenderFns = []

export { render, staticRenderFns }